import { ModuleWithProviders } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ZBDAppComponent } from "./app.component";
import { SearchComponent } from "./search/search.component";
import { EsignWidgetComponent } from "./print/esign/esignwidget.component";
import { AdminComponent } from "./admin/admin.component";
import { TokenExists, RolesExist } from "./utils/navigation-guards";
import { VersionComponent } from "./components/version.component";

const routes: Routes = [
    {
        path: "",
        component: SearchComponent,
        canActivate: [TokenExists, RolesExist],
    },
    { path: "version", component: VersionComponent, canActivate: [] },
    {
        path: ":protocolID",
        component: ZBDAppComponent,
        canActivate: [TokenExists, RolesExist],
    },
    {
        path: ":protocolID/esign",
        component: EsignWidgetComponent,
        canActivate: [TokenExists, RolesExist],
    },
    {
        path: ":protocolID/admin",
        component: AdminComponent,
        canActivate: [TokenExists, RolesExist],
    },
];

export const appRoutingProviders: any[] = [TokenExists, RolesExist];

export const routing: ModuleWithProviders<RouterModule> =
    RouterModule.forRoot(routes);
